import React, { useState, useEffect } from 'react';

const ChatWidget = () => {
  // State to track if the widget is being hovered over
  const [isHovered, setIsHovered] = useState(false);
  
  // State to track if the user is on a desktop-sized screen
  const [isDesktop, setIsDesktop] = useState(false);

  // --- IMPORTANT ---
  // Ensure these filenames match the files in your /public folder
  const staticIconSrc = '/whatsapp-static.png';
  const desktopHoverGifSrc = '/whatsapp-animated.gif';
  const mobileLoopGifSrc = '/mobile.gif';

  // Your WhatsApp details
  const phoneNumber = "919982069996"; // Country code without '+'
  const defaultMessage = "Hello! I'm interested in learning more about your school.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  // Effect to detect screen size
  useEffect(() => {
    const handleResize = () => {
      // We'll use 1024px as the breakpoint between mobile and desktop
      setIsDesktop(window.innerWidth > 1024);
    };

    handleResize(); // Check on initial load
    window.addEventListener('resize', handleResize); // Add listener for changes
    return () => window.removeEventListener('resize', handleResize); // Cleanup
  }, []);

  // --- Dynamic Image Source Logic ---
  const getImageSrc = () => {
    if (isDesktop) {
      // On desktop, switch between static and hover GIF
      return isHovered ? desktopHoverGifSrc : staticIconSrc;
    } else {
      // On mobile, always use the looping mobile GIF
      return mobileLoopGifSrc;
    }
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-end cursor-pointer group"
      aria-label="Chat with us on WhatsApp"
    >
      {/* The popup message: The `isDesktop` condition is REMOVED so it shows on mobile too */}
      <div 
        className="bg-white text-gray-800 text-base font-medium py-3 px-4 rounded-xl shadow-lg mb-2 mr-2 transition-all duration-300 ease-in-out transform group-hover:-translate-y-2">
        How can I help you?
      </div>
      
      {/* The mascot image container */}
      <div 
        className="w-16 h-auto transition-all duration-300 ease-in-out transform group-hover:scale-110"
        // --- CHANGE 1: Hover events are moved here ---
        // This isolates the hover effect to only the mascot image
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          // The src is determined by our clear logic function
          src={getImageSrc()}
          alt="Chat with our school mascot"
          className="w-full h-full object-contain"
        />
      </div>
    </a>
  );
};

export default ChatWidget;